{
  "name": "@nectary/components",
  "version": "2.8.8",
  "files": [
    "**/*/*.css",
    "**/*/*.json",
    "**/*/*.js",
    "**/*/*.d.ts",
    "standalone.ts",
    "standalone.d.ts",
    "standalone.js",
    "types.d.ts",
    "colors.json"
  ],
  "publishConfig": {
    "access": "public"
  },
  "scripts": {
    "build": "NODE_ENV=production babel . --extensions '.ts' --out-dir . && tsc --declaration --emitDeclarationOnly"
  },
  "dependencies": {
    "@babel/runtime": "^7.22.15"
  },
  "devDependencies": {
    "@babel/cli": "^7.22.15",
    "@babel/core": "^7.22.20",
    "@babel/plugin-transform-runtime": "^7.22.15",
    "@babel/preset-env": "^7.22.20",
    "@babel/preset-typescript": "^7.22.15",
    "@types/node": "^18.17.17",
    "@types/react": "^18.2.21",
    "babel-plugin-html-inline-minifier": "workspace:*",
    "typescript": "^5.2.2"
  }
}
